// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { FormInputWrapper } from "@insite/mobius/FormField";
import { filtersLayoutStyles } from "@steiner/App/Widgets/MyLists/MyListsFilterLayout";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

filtersLayoutStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: repeat(3, auto);
        column-gap: 22px;
        row-gap: 12px;
        align-items: end;
        ${FormInputWrapper} {
            width: 100%;
        }

        ${xScreen("lte", "md")} {
            grid-template-columns: repeat(2, auto);
            grid-template-rows: repeat(2, auto);
        }
        ${xScreen("lte", "sm")} {
            grid-template-columns: auto;
            grid-template-rows: repeat(3, auto);
        }
    `,
};
